// EP-150 (App Review 5.1.1v): /account/delete.
// The flow itself is AccountDeletionPanel, shared with the last Settings tab,
// which is where the app leads to it since 2026-09-29. This page stays for a
// direct link to the URL.
import { useTranslation } from 'react-i18next'
import { PageHeader, Breadcrumbs } from '@/components/layout'
import { useAccountDeletionStatus } from '@/hooks/useAccountDeletion'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'
import { AccountDeletionPanel } from './AccountDeletionPanel'

export function AccountDeletePage() {
  const { t } = useTranslation('account')
  // The same query the panel reads, shared through TanStack Query: the page
  // only needs the scope, for its title.
  const { data } = useAccountDeletionStatus()
  const heading = data?.scope === 'account' ? t('delete.title_account') : t('delete.title_user')

  useDocumentTitle(data ? heading : '')

  return (
    <div className="space-y-6">
      <Breadcrumbs items={[{ label: data ? heading : t('delete.title_account') }]} />
      <AccountDeletionPanel header={<PageHeader title={heading} />} />
    </div>
  )
}
